import React from 'react';
import { Button } from '@framework-controls/core';
import { strings } from 'src/localization';
import * as css from './ContactDealer.module.scss';
import classNames from 'classnames';

export interface Iprops {
    setDepartmentSpecs: (header: string) => void;
    label: string;
    sectionHeader: string;
    theme: string;
}

const DepartmentTile = (props: Iprops) => {
    let tileClass = css.tile;
    if (props.theme === 'cadillac') {
        tileClass = classNames (
            css.tile, css.tileCadillac,
        );
    }
    if ('Contact ' + props.label === props.sectionHeader) {
        tileClass = css.tileClicked;
        if (props.theme === 'colorSensitive') {
            tileClass = css.tileClickedCS;
        }

        if (props.theme === 'lexus') {
            tileClass = classNames (
                css.tileClicked, css.tileClickedLexus,
            );
        }

        if (props.theme === 'cadillac') {
            tileClass = classNames (
                css.tileClicked, css.tileClickedCadillac,
            );
        }
    }

    return (
        <div className={css.tileContainer}>
            <Button
                id={props.label}
                onClick={() => {
                    props.setDepartmentSpecs(`${strings.Contact} ${props.label}`);
                }}
                variant='contactUs'
            >
                <div
                    className={tileClass}
                >
                    {props.label}
                </div>
            </Button>
        </div>
    );
};

export default DepartmentTile;